<template>
    <div class="social-share">
        <ul>
            <li>
                <a href="https://www.facebook.com/Komvac.Software" class="share-fb">
                    <span><ion-icon name="logo-facebook"></ion-icon></span>
                </a>
            </li>
            <li>
                <a @click="openLink(shareSocialMedia('twitter', metas.url))" class="share-twitter">
                    <span><ion-icon name="logo-twitter"></ion-icon></span>
                </a>
            </li>
            <!-- <li>
                <a @click="openLink(shareSocialMedia('linkedin', metas.url, metas.title))" class="share-google-plus">
                    <span><ion-icon name="logo-linkedin"></ion-icon></span>
                </a>
            </li> -->
            <li>
                <a @click="openLink(shareSocialMedia('whatsapp', metas.url))" class="fa fa-whatsapp">
                    <ion-icon name="logo-whatsapp"></ion-icon>
                </a>
            </li>
            <li>
                <a @click="openLink(shareSocialMedia('email', metas.url, metas.title))" class="fa fa-mail">
                    <ion-icon name="mail-outline"></ion-icon>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import tools from '../tools'

export default {
    mounted() {
        this.getMetaTags()
    },
    data() {
        return {
            loading: false,
            metas: {
                title: '',
                url: ''
            }
        }
    },
    methods: {
        openLink(string) {
            window.open(string, "social_media_share", "height=320, width=640, toolbar=no, menubar=no, scrollbars=yes, resizable=yes, location=no, directories=no, status=no")
        },
        getMetaTags() {
            if (document.head.querySelector('meta[property="og:title"]')) {
                this.metas.title = document.head.querySelector('meta[property="og:title"]').getAttribute('content')
                this.metas.url = document.head.querySelector('meta[property="og:url"]').getAttribute('content')
            }
        },
        shareSocialMedia: tools.shareSocialMedia
    }
}
</script>